import { onboardingThirdPartyApi } from 'onboarding/classes/services/api/OnboardingThirdPartyApi'

class ThirdPartyService {
  public refreshProfileStatus(actionId: number) {
    return onboardingThirdPartyApi.refreshProfileStatus(actionId)
  }
}

export const thirdPartyService = new ThirdPartyService()
